
import { defineComponent, ref } from "vue";
import Results from "../../components/results/Results.vue";
import SearchInput from "../../components/form/SearchInput.vue";
import Button from "../../components/buttons/Button.vue";
import Select from "../../components/form/Select.vue";
import Modal from "../../components/Modal.vue";
import { rooms, places, polishTranslate } from "@book-searcher/data";
import type { Book } from "@book-searcher/types";
import { HTMLInputEvent } from "../../types";
import { useForm, useField } from "vee-validate";
import { moveBookSchema } from "../../utils/validationSchemas";
import { prepareQueryToSearch } from "../../utils/functions";
import { useBooks } from "../../utils/composable/useBooks";
import { useBook } from "../../utils/composable/useBook";

export default defineComponent({
  components: {
    Results,
    SearchInput,
    Modal,
    Button,
    Select,
  },
  setup() {
    const selectedBook = ref({} as Book);
    const modalOpen = ref(false);

    const { getBooks, loading, results } = useBooks();
    const { moveBook } = useBook();

    const { handleSubmit, errors } = useForm({
      validationSchema: moveBookSchema,
    });

    getBooks("/");

    const handleFilterBooks = (e: HTMLInputEvent) => {
      if (e.target?.value) {
        return getBooks(
          `/search?type=basic&q=${prepareQueryToSearch(e.target?.value)}`,
        );
      }
    };

    const handleOpenMoveModal = (slug: string) => {
      modalOpen.value = true;
      selectedBook.value =
        results.value.find((item: Book) => item.slug === slug) || ({} as Book);
    };

    const handleMoveBook = handleSubmit((data, { resetForm }) => {
      modalOpen.value = false;
      resetForm();
      return moveBook({
        id: selectedBook.value.id,
        ...data,
      } as { id: number; room: string; place: string });
    });

    const { value: room } = useField("room");
    const { value: place } = useField("place");

    return {
      getBooks,
      handleFilterBooks,
      handleOpenMoveModal,
      selectedBook,
      modalOpen,
      rooms,
      places,
      polishTranslate,
      errors,
      room,
      place,
      handleMoveBook,
      loading,
    };
  },
});
